import React from 'react';
import { Info } from 'lucide-react';
export const Authority: React.FC = () => {
  return <section className="py-16 md:py-24 px-4 max-w-3xl mx-auto text-center" data-id="element-23">
      <h2 className="font-serif text-3xl md:text-4xl text-earth font-bold mb-6" data-id="element-24">
        Tu embarazo merece claridad, no incertidumbre.
      </h2>

      <p className="font-sans text-lg text-earth-light mb-8 leading-relaxed" data-id="element-25">
        Los antiácidos de farmacia solo apagan el síntoma temporalmente, pero no
        resuelven la raíz del problema. Nuestro método aborda directamente los
        cambios en la progesterona y la presión mecánica de tu útero, dándote
        herramientas naturales y efectivas para prevenir el ardor antes de que
        empiece.
      </p>

      <div className="inline-flex items-center gap-2 text-xs text-earth-light/70 italic bg-cream-card px-4 py-2 rounded-full" data-id="element-26">
        <Info size={14} data-id="element-27" />
        <span data-id="element-28">Contenido educativo, no reemplaza consulta médica.</span>
      </div>
    </section>;
};